import {
  ActionAddUnallocatedMiner,
  ActionRemoveUnallocatedMiner,
  ActionReorderItems,
  ActionSetMinerColor,
  ActionSetUnallocatedMiners,
  ActionTypesUnallocatedMiners,
  ActionUnracksInvalidate,
  IUnrackItem,
} from "./actionTypes";

export const setUnallocatedMiners = (
  payload: IUnrackItem[]
): ActionSetUnallocatedMiners => {
  return {
    type: ActionTypesUnallocatedMiners.SET_MINERS,
    payload,
  };
};

export const removeUnallocatedMiner = (
  payload: number
): ActionRemoveUnallocatedMiner => {
  return {
    type: ActionTypesUnallocatedMiners.REMOVE_MINER,
    payload,
  };
};

export const addUnallocatedMiner = (
  payload: IUnrackItem
): ActionAddUnallocatedMiner => {
  return {
    type: ActionTypesUnallocatedMiners.ADD_MINER,
    payload,
  };
};

export const unracksInvalidate = (): ActionUnracksInvalidate => ({
  type: ActionTypesUnallocatedMiners.UNRACKS_INVALIDATE,
});

export const reorderUnnalocatedItems = (
  payload: ActionReorderItems["payload"]
): ActionReorderItems => {
  return {
    type: ActionTypesUnallocatedMiners.REORDER_ITEMS,
    payload,
  };
};

export const setUnrackMinerColor = (
  user_id: string,
  color: string
): ActionSetMinerColor => {
  return {
    type: ActionTypesUnallocatedMiners.SET_MINER_COLOR,
    payload: { user_id, color },
  };
};
